import React from 'react'
import { IconButton, makeStyles, PopoverPosition } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import Wysiwyg from '../Wysiwyg'
import FileUpload from './FileUpload'
import store, { IBlock } from '../../store'
import { observer } from 'mobx-react'
import Link from '../Link'

const useStyles = makeStyles(theme => ({
  margin: {
    margin: theme.spacing(1)
  }
}))

interface Props {
  block: IBlock
}

const Block = (props: Props) => {
  const classes = useStyles()

  return (
    <div style={{ padding: 10 }}>
      <IconButton
        size="small"
        style={{ float: 'right' }}
        onClick={() => {
          store.deleteBlock(props.block)
        }}
      >
        <CloseIcon fontSize="inherit" />
      </IconButton>
      {props.block.type === 'DEFAULT' && (
        <>
          <FileUpload />
          <Wysiwyg />
        </>
      )}
      {props.block.type === 'FILE' && <FileUpload />}
      {props.block.type === 'NOTE' && <Wysiwyg />}
      {props.block.type === 'TEXT' && (
        <input
          type="text"
          style={{ width: '100%' }}
          autoFocus
          onKeyDown={e => {
            if (e.key === 'Enter') {
              store.addBlock('TEXT')
            }
          }}
        />
      )}
      {props.block.type === 'LINK' && <Link />}
    </div>
  )
}

export default observer(Block)
